// default airport to use for transfers pricing if none specified
const defaultAirport = 'Dublin Airport';
const defaultAirportCity = 'DUB';

// transfer to information to use for all bookings
// this is to save creating transfers for every town in Donegal
const traiToCity = 'DONE';
const traiPartialToPoint = '<nextacc>';

// transfer from information to use for all bookings
// this is to save creating transfers for every town in Donegal
const traoFromCity = 'DONE';
const traoPartialFromPoint = '<previousacc>';


const state = {
    requireTransfers: 'yes',
    inboundAirport: null,
    outboundAirport: null,
    transferIn: null,
    transferOut: null,
};

const getters = { 
    getTransferIn: (state, getters) => {
        if (getters.getFirstHotel != null) {
            if (state.requireTransfers == 'yes' && state.transferIn != null) {
                return `Transfer from ${state.inboundAirport.name} to ${getters.getFirstHotel.title}`;
            } else if (state.requireTransfers == 'no' && state.transferIn != null) {
                return `Transfer from Airport to ${getters.getLastHotel.title}`;
            } else if (state.requireTransfers == 'none') {
                return `Own transport to ${getters.getLastHotel.title}`;
            } else {
                return `Transfer arrangements to be confirmed (quoted price won't include transfers)`;
            }
        }

        return '';
    },
    getTransferInProductId: (state, getters) => {
        if (state.requireTransfers != 'none' && state.transferIn != null && getters.getFirstHotel != null) {
            return state.transferIn.productId;
        }
        return 0
    },
    getFallbackTrai: (state, getters) => {
        return getters.getCountyTransfersIn.find((t) => { 
            return t.fromCity.cityCode == defaultAirportCity &&
                // from point has max length of 20
                // airport name has max length of 39 
                t.fromPoint == defaultAirport.substring(0, 20) &&
                t.toCity.cityCode == traiToCity &&
                t.toPoint.toLowerCase().includes(traiPartialToPoint);
        });
    },
    getTransferOut: (state, getters) => {
        if (getters.getLastHotel != null) {
            if (state.requireTransfers == 'yes' && state.transferOut != null) {
                return `Transfer from ${getters.getLastHotel.title} to ${state.outboundAirport.name}`;
            } else if(state.requireTransfers == 'no' && state.transferOut != null) {
                return `Transfer from ${getters.getLastHotel.title} to Airport`;
            } else if (state.requireTransfers == 'none') {
                return `Own transport departing Donegal`;
            } else {
                return `Transfer arrangements to be confirmed (quoted price won't include transfers)`;
            }
        }
        return '';
    },
    getTransferOutProductId: (state, getters) => {
        if (state.requireTransfers != 'none' && state.transferOut != null && getters.getLastHotel != null) {
            return state.transferOut.productId;
        }
        return 0
    },
    getFallbackTrao: (state, getters) => {
        return getters.getCountyTransfersOut.find((t) => { 
            return t.fromCity.cityCode == traoFromCity && 
                   t.fromPoint.toLowerCase().includes(traoPartialFromPoint) &&
                   t.toCity.cityCode == defaultAirportCity &&
                   // from point has max length of 20
                   // airport name has max length of 30
                   t.toPoint == defaultAirport.substring(0, 20);
            });
    },
}

const mutations = {
    setRequireTransfers: (state, payload) => { state.requireTransfers = payload; },
    setInboundAirport: (state, payload) => { state.inboundAirport = payload },
    setOutboundAirport: (state, payload) => { state.outboundAirport = payload },
    setTransferIn: (state, payload) => { state.transferIn = payload; },
    setTransferOut: (state, payload) => { state.transferOut = payload; } 
};

const actions = { 
    setRequireTransfers: ({ state, commit }, payload) => {
        if (state.requireTransfers != payload) {
            // clear any previous selections
            commit('setInboundAirport', null);
            commit('setOutboundAirport', null);
            commit('setTransferIn', null);
            commit('setTransferOut', null);

            // finally set the state
            commit('setRequireTransfers', payload);
        }
    },
    setInboundAirport: ({ state, commit, dispatch }, payload) => {
        if (state.inboundAirport != payload) {
            commit('setInboundAirport', payload);
        }
    },
    setOutboundAirport: ({ state, commit, dispatch }, payload) => {
        if (state.outboundAirport != payload) {
            commit('setOutboundAirport', payload);
        }
    },
    checkTransfers: ({ state, getters, commit }) => {
        // check for transfers regardles of whether airports have been specified
        let firstHotel = getters.getFirstHotel;
        let lastHotel = getters.getLastHotel;

        let trai = null;
        let trao = null;

        if (firstHotel != null && lastHotel != null) {
            if (state.inboundAirport != null) {
                trai = getters.getCountyTransfersIn.find((t) => { 
                    return t.fromCity.cityId == state.inboundAirport.cityId &&
                            // from point has max length of 20
                            // airport name has max length of 30
                            t.fromPoint == state.inboundAirport.name.substring(0, 20) &&
                            t.toCity.cityCode == traiToCity &&
                            t.toPoint.toLowerCase().includes(traiPartialToPoint);
                });
            }
            
            if (state.outboundAirport != null) {
                trao = getters.getCountyTransfersOut.find((t) => {
                    return t.fromCity.cityCode == traoFromCity &&
                            t.fromPoint.toLowerCase().includes(traoPartialFromPoint) && 
                            t.toCity.cityId == state.inboundAirport.cityId &&
                            // from point has max length of 20
                            // airport name has max length of 30
                            t.toPoint == state.inboundAirport.name.substring(0, 20);
                });
            }
        }

        if (!trai) {
            trai = getters.getFallbackTrai;
        }

        if (!trao) {
            trao = getters.getFallbackTrao;
        }

        commit('setTransferIn', trai);
        commit('setTransferOut', trao);    
    }
};

export default { 
    state, 
    getters,
    mutations,
    actions
};
